'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';
import { useSilentRouter } from '@shared/hooks/use-router';
import AuthSection from '@/components/auth-section';

import { REDIRECT_PATH } from '@/utils/constants';

import { BaseOnboardingModal } from './base-onboarding-modal';

interface AuthModalProps {
	open: boolean;
	onAuthSuccess: () => void;
	onClose?: () => void;
	showCloseButton?: boolean;
	closeButtonTooltip?: string;
}

export function AuthModal({
	open,
	onAuthSuccess,
	onClose,
	showCloseButton = false,
	closeButtonTooltip,
}: AuthModalProps) {
	const pathname = usePathname();
	const router = useSilentRouter();

	// Set redirect path in URL when modal opens so OAuth knows where to return
	useEffect(() => {
		if (open && pathname) {
			const url = new URL(window.location.href);
			if (!url.searchParams.has(REDIRECT_PATH)) {
				url.searchParams.set(REDIRECT_PATH, encodeURIComponent(pathname));
				router.replace(url.pathname + url.search, { scroll: false });
			}
		}
	}, [open, pathname, router]);

	return (
		<BaseOnboardingModal
			open={open}
			transparent={true}
			onClose={onClose}
		>
			<AuthSection
				onAuthSuccess={onAuthSuccess}
				skipRedirect={true}
				insideOnboarding
				onClose={onClose}
				showCloseButton={showCloseButton}
				closeButtonTooltip={closeButtonTooltip}
			/>
		</BaseOnboardingModal>
	);
}
